import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { Manobras } from '../models/manobras';

@Injectable({
  providedIn: 'root',
})
export class AtividadeManobrasService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore;
  }

  getAtividadeManobras(idAtividade: number): Observable<Manobras[]> {
    const url = this.environmentUrl + 'atividade/' + idAtividade + '/manobra';
    return this.httpClient.get<Manobras[]>(url);
  }

  updManobras(body: any) {
    const url = this.environmentUrl + 'atividade/Manobra';
    return this.httpClient.put(url, body);
  }
}
